import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLeftBold = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 9,
	height: 12,
	viewBox: "0 0 9 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.20492 1.41L6.79492 0L0.794922 6L6.79492 12L8.20492 10.59L3.62492 6L8.20492 1.41Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgChevronLeftBold);
export { ForwardRef as ReactComponent };
